import React, {useState} from "react";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Typography
} from "@mui/material";
import {post} from "../../api/api";
import {useAppStore} from "../../store/appStore";
import {showMessage} from "../../utils/snackbar";

const PrivacyPolicy: React.FC = () => {
    const [checked, setChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onAgree = async () => {
        setIsSubmitting(true);
        try {
            const userModel = await post("/me/privacy-policy");
            useAppStore.setState({userModel});
        } catch (error) {
            console.warn("Failed to accept privacy policy: ", error);
        } finally {
            setIsSubmitting(false)
        }
    };

    return (
        <Dialog open={true} maxWidth="md" fullWidth>
            <DialogTitle>Privacyverklaring Medendo</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" component="p">
                    Laatst bijgewerkt: 11 november 2024
                </Typography>

                <Typography variant="h6" mt='24px'>Inleiding</Typography>
                <Typography variant="body2" component="p">
                    In deze privacyverklaring leggen wij uit hoe we omgaan met je persoonsgegevens, waarom we deze
                    nodig hebben en wat je rechten hierin zijn. Hiermee voldoen wij aan de eisen van de Algemene
                    Verordening Gegevensbescherming (AVG).
                </Typography>

                <Typography variant="h6" mt='24px'>Wie zijn wij?</Typography>
                <Typography variant="body2" component="p">
                    Als verwerkingsverantwoordelijke is Medendo verantwoordelijk voor de verwerking van jouw
                    gegevens volgens de AVG. Neem voor meer informatie contact op via <a
                    href="mailto:privacy@medendo.com">privacy@medendo.com</a>.
                </Typography>

                <Typography variant="h6" mt='24px'>Verwerking van persoonsgegevens</Typography>
                <Typography variant="body2" component="p">
                    Wij verwerken onder andere audio-opnames, transcripties, sjablonen, rapporten, contactgegevens
                    (naam, e-mail) en gebruiksgegevens zoals IP-adres, foutmeldingen, gebruiksduur, gebruiksfrequentie en andere gegevens voor het verbeteren van onze diensten.
                </Typography>

                <Typography variant="h6" mt='24px'>Delen van persoonsgegevens</Typography>
                <Typography variant="body2" component="p">
                    Gegevens worden niet gedeeld met derden binnen of buiten de Europese Economische Ruimte (EER).
                </Typography>

                <Typography variant="h6" mt='24px'>Organisatorische en technische maatregelen</Typography>
                <Typography variant="body2" component="p">
                    Medendo is ISO 27001 en NEN 7510 gecertificeerd. Alle gegevens worden versleuteld en medewerkers
                    tekenen geheimhoudingsovereenkomsten.
                </Typography>

                <Typography variant="h6" mt='24px'>Jouw rechten</Typography>
                <Typography variant="body2" component="p">
                    Je hebt recht op inzage, correctie, verwijdering, beperking, bezwaar en dataportabiliteit. Neem
                    contact op via <a href="mailto:privacy@medendo.com">privacy@medendo.com</a> om je rechten uit te
                    oefenen.
                </Typography>

                <Typography variant="h6" mt='24px'>Klachtenrecht</Typography>
                <Typography variant="body2" component="p">
                    Je kunt klachten indienen bij de Autoriteit Persoonsgegevens via <a
                    href="https://www.autoriteitpersoonsgegevens.nl" target="_blank"
                    rel="noopener noreferrer">www.autoriteitpersoonsgegevens.nl</a>.
                </Typography>

                <Typography variant="h6" mt='24px'>Geen verwerking van kinderdata</Typography>
                <Typography variant="body2" component="p">
                    Medendo verwerkt geen gegevens van kinderen jonger dan 18 jaar. Eventuele gegevens worden
                    onmiddellijk verwijderd zodra we hiervan op de hoogte zijn.
                </Typography>
            </DialogContent>
            <DialogActions>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={(e) => setChecked(e.target.checked)}
                            name="accept"
                        />
                    }
                    label="Ik ga akkoord met de privacyverklaring"
                />
                <Button onClick={onAgree} disabled={!checked || isSubmitting} variant="contained" color="primary">
                    Akkoord
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PrivacyPolicy;
